export default __webpack_public_path__ + "static/media/logo-borderless.e73fc2a9.svg";